export enum ModalityEnum {
	THERAPIES = 6,
	HOSPITALIZATIONS = 4,
	CONSULT = 1,
	EXAMS = 3,
}

export type PostCreateRequestPreviewParams = {
	email: string;
	phoneNumber: string;
	modality: string;
	modalityCode: string;
	description: string;
	patientCode: string;
};

export type PostCreateRequestPreviewResponse = {
	content: {
		protocol: string;
		protocolCode: string;
		requestCode: string;
		request: string;
	};
};

export interface PostCreateRequestPreview {
	post: (params: PostCreateRequestPreviewParams) => Promise<PostCreateRequestPreviewResponse>;
}
